<template>
  <div>
    <echarts-menuTwo
      :dataMenu="dataMenu"
      @changeydata="onchangeData"
    ></echarts-menuTwo>
    <textEchartsTwo
      v-if="showChartOrList"
      :data="showData"
      class="echarts"
    ></textEchartsTwo>
    <home-tableTwo v-else></home-tableTwo>
  </div>
</template>
<script>
import echartsMenuTwo from "./echarts-menuTwo.vue";
import textEchartsTwo from "./text-echartsTwo.vue";
import homeTableTwo from "./homeTableTwo.vue";
import { storeMainInfo } from "@/api/storeApi.js";
export default {
  data() {
    return {
      date: {
        endDate: "",
        startDate: "",
      },
      showChartOrList: true,
      dataMenu: {
        orderNumData: {
          name: "下单数量（最近15日）",
          val: "orderNumData",
          index: 1,
        },
        orderMoneyData: {
          name: "下单金额（最近15日）",
          val: "orderMoneyData",
          index: 2,
        },
        // countNewUserNum: {
        //   name: "日新增会员用",
        //   val: "countNewUserNum",
        //   index: 3,
        // },
        // accountChartLoginMonthData: {
        //   name: "用户活跃度",
        //   val: "accountChartLoginMonthData",
        //   index: 4,
        // },
        // hydbb: {
        //   name: "活跃度报表",
        //   val: "hydbb",
        //   index: 5,
        // },
      },
      showData: [],
      Ydata: {
        orderNumData: [],
        orderMoneyData: [],
        countNewUserNum: [],
        accountChartLoginMonthData: [],
        hydbb: [],
      },
    };
  },
  components: {
    echartsMenuTwo,
    textEchartsTwo,
    homeTableTwo,
  },
  mounted() {
    this.getMainInfo();
  },
  methods: {
    onchangeData(val) {
      this.showData = this.Ydata[val.val];
      if (val.val === "hydbb") {
        // false为显示报表，true显示图表
        this.showChartOrList = false;
      } else {
        this.showChartOrList = true;
      }
    },
    getMainInfo() {
      storeMainInfo(this.date).then((res) => {
        this.Ydata.orderNumData = res.data.orderNumData || [];
        this.Ydata.orderMoneyData = res.data.orderMoneyData || [];
        
        // 默认显示第一个菜单项的数据
        this.showData = this.Ydata.orderNumData;
        
        console.log("Ydata updated:", this.Ydata);
        console.log("showData updated:", this.showData);
      }).catch(err => {
        console.error("获取首页图表数据失败", err);
      });
    },
  },
};
</script>
<style>
.echarts {
  /* width: 1115px; */
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeEchatrsTwo.vue